<div class="igo-mini-basemap-container">
  @if (display()) {
    <div (click)="changeBaseLayer(baseLayer())">
      <igo-map-browser [map]="basemap" />
      @if (title()) {
        <div class="igo-mini-basemap-title">{{ title() }}</div>
      }
    </div>
  }
</div>
